import { useMemo } from 'react'

import { getFieldIcon } from 'features/admin/fields/icons/utils'
import { HighlightsWidgetAttributeItem } from 'features/views/LayoutEditor/widgets/HighlightsWidget/attributes/types'

type BaseAttributeStateProps = {
    item: HighlightsWidgetAttributeItem
}

export function useBaseAttributeState({ item }: BaseAttributeStateProps) {
    const fieldIcon = item.icon || getFieldIcon(item.field)

    const label = item.label || item.field.label

    return useMemo(
        () => ({
            fieldIcon,
            label,
        }),
        [fieldIcon, label]
    )
}
